import { Button, Space } from "antd";
import styled from "styled-components";

export const StyledContainer = styled(Space.Compact)`
    flex-shrink: 0;
    width: auto;
    max-width: 100%;
    display: flex;
`;

export const StyledButton = styled(Button)`
    width: auto;
    aspect-ratio: 1/1;
    padding: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
`;
